import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sf_token');
    const cached = localStorage.getItem('sf_user');
    if (token && cached) {
      try { setUser(JSON.parse(cached)); } catch {}
      api.get('/auth/me').then((r) => {
        setUser(r.data);
        localStorage.setItem('sf_user', JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem('sf_token');
        localStorage.removeItem('sf_user');
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    localStorage.setItem('sf_token', r.data.access_token);
    localStorage.setItem('sf_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name, role = 'hunter') => {
    const r = await api.post('/auth/register', { email, password, name, role });
    localStorage.setItem('sf_token', r.data.access_token);
    localStorage.setItem('sf_user', JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem('sf_token');
    localStorage.removeItem('sf_user');
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
